/* eslint-disable no-plusplus -- this shit is getting out of hand */
/* eslint-disable no-await-in-loop -- this shit is getting out of hand */
import { GetDeviceSnapshotDTO } from '@eppendorf/vnls-device-service-utils';
import { useMutation } from '@tanstack/react-query';

import { fetcher } from '$shared/fetch';
import { createMonitorPath } from '$shared/utils/api-paths';

import { useDeviceSnapshot } from '$features/monitoring/device-snapshot.api';
import { ThresholdsFormProfile } from '$features/monitoring/parameters/thresholds-form';
import {
  AlertConfig,
  AlertConfigThresholdLevel,
  AlertConfigThresholdType,
} from '$features/monitoring/parameters/types';

type AlertConfigUpdateResult = {
  //
};

type UpdateThresholdsPayload = {
  telemetryId: string;
  thresholds: ThresholdsFormProfile;
};

export const mapThresholdsToAlertConfig = (
  thresholds: ThresholdsFormProfile,
): AlertConfig => ({
  active: thresholds.active,
  thresholds: [
    {
      type: AlertConfigThresholdType.Alert,
      level: AlertConfigThresholdLevel.High,
      value: +thresholds.alertHigh,
    },
    {
      type: AlertConfigThresholdType.Alert,
      level: AlertConfigThresholdLevel.Low,
      value: +thresholds.alertLow,
    },
    {
      type: AlertConfigThresholdType.Warn,
      level: AlertConfigThresholdLevel.High,
      value: +thresholds.warnHigh,
    },
    {
      type: AlertConfigThresholdType.Warn,
      level: AlertConfigThresholdLevel.Low,
      value: +thresholds.warnLow,
    },
  ],
});

function isSnapshotUpdatedWithNewThresholds(
  snapshot: GetDeviceSnapshotDTO,
  telemetryId: string,
  thresholds: ThresholdsFormProfile,
): boolean {
  const component = snapshot.currentShadow.components.find(
    (comp) => comp.id === telemetryId,
  );

  if (!component) {
    return false;
  }

  const { alertThreshold, warnThreshold, alertingEnabled } = component;

  return (
    alertingEnabled === thresholds.active &&
    alertThreshold?.high === +thresholds.alertHigh &&
    alertThreshold?.low === +thresholds.alertLow &&
    warnThreshold?.high === +thresholds.warnHigh &&
    warnThreshold?.low === +thresholds.warnLow
  );
}

export const useUpdateThresholdsSnapshot = (deviceId: string) => {
  const retryDelay = 1000;
  const totalRetryCount = 10;
  const { invalidate: getCurrentSnapshot } = useDeviceSnapshot({
    manufacturer: 'Eppendorf',
    serialNumber: deviceId,
  });

  const update = async ({ telemetryId, thresholds }: UpdateThresholdsPayload) => {
    await fetcher.put<AlertConfig, AlertConfigUpdateResult>(
      createMonitorPath(deviceId, `alertConfig/${encodeURI(telemetryId)}`),
      mapThresholdsToAlertConfig(thresholds),
    );

    let attempt = 0;
    while (attempt < totalRetryCount) {
      const snapshot = await getCurrentSnapshot();
      if (isSnapshotUpdatedWithNewThresholds(snapshot, telemetryId, thresholds)) {
        return;
      }
      attempt++;
      await new Promise((resolve) => {
        setTimeout(resolve, retryDelay);
      });
    }
  };

  return useMutation({ mutationFn: update });
};

/* eslint-enable no-plusplus */
/* eslint-enable no-await-in-loop */
